<template>
  <section class="section" v-show="false">
    <a href="https://www.mhlw.go.jp/stf/newpage_09690.html" target="_blank">
      <div class="container">
        <div class="content">
          <div class="badge">政府</div>
          <div class="message">厚生労働省の対応について</div>
        </div>
        <div class="arrow">
          <Icon type="next" />
        </div>
      </div>
    </a>
  </section>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'Announcement',
  components: {
    Icon,
  },
}
</script>

<style lang="less" scoped>
a {
  text-decoration: none;
}
.section {
  padding: 12px 24px;
  background-color: hsl(0, 0%, 98%);
}
.container {
  width: 100%;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
  background-color: #fff;
  padding: 6px 12px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  text-align: left;
  cursor: pointer;
  &, a {
    color: #333;
  }
  .content {
    flex: 1;
    display: flex;
    justify-content: left;
    align-items: flex-start;
    .badge {
      font-size: 12px;
      line-height: 1em;
      padding: 4px 8px;
      margin: 4px 6px 4px 0;
      color: hsl(8, 93%, 58%);
      background-color: hsl(7, 100%, 96%);
    }
    .message {
      flex: 1;
      font-size: 14px;
      line-height: 26px;
    }
  }
  .arrow {
    padding: 0 0 0 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }
}
</style>
